export const COHORT_TIER_KEY = {
  NOT_LOGGED_IN: 'not-logged-in',
  NO_TIER: 'no-tier',
  BASE_TIER: 'monetary-cohort-base-tier',
  TIER_1: 'monetary-cohort-tier-1',
  TIER_2: 'monetary-cohort-tier-2',
  TIER_3: 'monetary-cohort-tier-3',
  TIER_4: 'monetary-cohort-tier-4',
} as const;
